export enum MachineConnectionColors {
  RED = 'red',
  ORANGE = 'orange',
  GREEN = 'green',
}
